import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MantineProvider, createTheme } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

// NOTE: The `brand` scale below should stay in sync with the --primary token
// in src/index.css. Step 5 (#e67e22) is the canonical brand color.
const theme = createTheme({
  primaryColor: "brand",
  primaryShade: 5,
  white: "#ffffff",
  black: "#1c1917",
  colors: {
    brand: [
      "#fef6ed",
      "#fce8cc",
      "#f9d2a0",
      "#f5b972",
      "#f19c44",
      "#e67e22", // primary — matches --primary
      "#c7641b", // hover — matches --primary-hover region
      "#a34e15",
      "#7d3b11",
      "#52260b",
    ],
  },
  fontFamily:
    '"Nunito Sans", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
  headings: {
    fontFamily: '"DM Serif Display", ui-serif, Georgia, Cambria, "Times New Roman", serif',
  },
});

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <Notifications />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MantineProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
